// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3M7om","select":"Header_select__27mbh","clinic":"Header_clinic__lMXfE"};